import logo from 'assets/images/kukyang/logo.png';

// ==============================|| LOGO ICON IMAGE ||============================== //

export default function LogoIcon() {
  return <img src={logo} alt="Kukyang" style={{ height: '100%', width: 'auto', objectFit: 'contain', display: 'block' }} />;
}
